module.exports = __webpack_public_path__ + "img/cv.153bda9.svg";